export default class AppEnviroment {
    private static gatewayUrl = process.env.REACT_APP_HST_GATEWAY_URL || "http://localhost:8080/api"
    private static pwaUrl = process.env.REACT_APP_HST_PWA_URL || 'http://localhost:3000/';
    private static recaptchaSite = process.env.REACT_APP_HST_RECAPTCHA_SITE || '6LeaLLcsAAAAAKsfEpWXW2aKX5RcM32QU0oZGPII';
    
    public static getGatewayUrl(){
        return this.gatewayUrl;
    }
     public static getPwaUrl(){
        return this.pwaUrl;
    }

    public static getRecaptchaSite(){
        return this.recaptchaSite;
    }
}